import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import StarsRating from 'Pods/Shared/StarsRating'
import Icon from 'Pods/Shared/Icon/Icon'
import Progressbar from 'Pods/Shared/Progressbar'

function RatingTooltip({ userRatings = {
  project: {
    count: 0,
    avgRating: 0,
  },
  model: {
    count: 0,
    positive: 0,
    negative: 0,
  },
} }) {
  return (
    <Fragment>
      <section className="tooltip-rating__section">
        <h4 className="heading-16">
          {i18n.t('titles.3d_projects', { ns: 'global' })} <span>{`(${userRatings.project.count} ratings)`}</span>
        </h4>
        <StarsRating rating={userRatings.project.avgRating} />
      </section>

      <section className="tooltip-rating__section">
        <h4 className="heading-16">
          {i18n.t('titles.3d_models', { ns: 'global' })} <span>{`(${userRatings.model.count} ratings)`}</span>
        </h4>
        <div className="user-tooltip__rating">
          <div className="product-ratings">
            <span className="product-ratings__thumbs">
              <span>
                <Icon type="thumbs-up" color="green-dark" />
                {userRatings.model.positive}
              </span>
              <span>
                <Icon type="thumbs-down" color="grey" />
                {userRatings.model.negative}
              </span>
            </span>
            <div className="product-ratings__bar">
              <Progressbar
                value={userRatings.model.positive}
                maxValue={userRatings.model.positive + userRatings.model.negative}
                labelSize="label-none"
                barColor="is-dark"
              />
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  )
}

RatingTooltip.propTypes = {
  userRatings: PropTypes.shape({
    project: PropTypes.shape({
      count: PropTypes.number,
      avgRating: PropTypes.number,
    }).isRequired,
    model: PropTypes.shape({
      count: PropTypes.number,
      positive: PropTypes.number,
      negative: PropTypes.number,
    }).isRequired,
  }).isRequired,
}

export default RatingTooltip
